import React, { useState } from "react";
import { connect } from "react-redux";
import { createStore } from "devextreme-aspnet-data-nojquery";
import ChargeSearchFormResult from "../maintabs/chargdetail/ChargeSearchFormResult";
import ChargeSearchForm from "../maintabs/chargdetail/ChargeSearchForm";

const WMChargesDetails = (props) => {
    const orderStatus = "0";
    const getDataUrl = "wm/TransactionManagement/GetTransactionChargeDetails";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState("UnInv Chg");
    const accessToken = props.oidc.user.access_token;
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);

    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: "rowId",
            loadParams: {
                ChargeCode: () => formFields.ChargeCode,
                Description_1: () => formFields.Description_1,
                RCustomer: () => formFields.RCustomer,
                CustomerName: () => formFields.CustomerName,
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };

    const searchData = (formFields) => {
        const resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };

    const searchPanelData = (resultData) => {
        
        setSearchPanelStatus(resultData);
      };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <ChargeSearchForm pageTitle={pageTitle} searchData={searchData} searchPanelData={searchPanelData}  />
                        <ChargeSearchFormResult data={dataSource} searchPanelStatus={searchPanelStatus} />
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMChargesDetails);
